import { useState, useEffect } from "react";
import { useMainIndexList } from "utils/clientAPIs/MainStockList";
import { StockListSkeleton } from "components/skeleton/main";
import CustomToast, {
  KbPasswordReAuthToast,
} from "components/atoms/CustomToast";
import { useKbPassword } from "utils/kb/password";
import { passwordExpiredToastState } from "states/KbState";
import { useRecoilState } from "recoil";
import { useKBGlobalState } from "contexts/KBContext";
import HighScoreList from "./explore/HighScoreList";
import IndexList from "./explore/IndexList";
import Strategies from "./explore/Strategies";
import HighMomentum from "./explore/HighMomentum";
import HotTopicList from "./explore/HotTopicList";
import MainNewLeader from "./explore/NewLader";
import Planner from "./explore/Planner";
import AdSenseResponsive, {
  AD_SLOTS,
} from "components/ads/AdSenseResponsive";

function StockLIstIndex({
  isMobile,
  isLoginUser,
  initialHighScoreList,
  initialHotTopicList,
  initialMainIndex,
}: {
  isMobile: boolean;
  isLoginUser: boolean;
  initialHighScoreList?: any[] | null;
  initialHotTopicList?: any[] | null;
  initialMainIndex?: { index?: any[] } | null;
}) {
  const [passwordExpiredToast, setPasswordExpiredToast] = useRecoilState(
    passwordExpiredToastState
  );
  const { mainScreenPasswordSuccess, setMainScreenPasswordSuccess } =
    useKBGlobalState();

  const [indexList, indexLoading] = useMainIndexList(initialMainIndex);

  const [reAuthPassword, setReAuthPassword] = useState(false);
  const [
    encryptedPassword,
    PasswordScreen,
    inPasswordMode,
    load,
    getPasswordFetch,
  ] = useKbPassword(isMobile, false);
  const loading = indexLoading; //isKoreanLoading || isUsLoading;|| isCryptoLoading;

  if (reAuthPassword && inPasswordMode) {
    return (
      <PasswordScreen
        backHandler={() => {
          setReAuthPassword(false);
        }}
      />
    );
  }

  return (
    <div>
      <IndexList indexList={[...indexList]} />
      <MainNewLeader />
      <HighScoreList initialList={initialHighScoreList} />
      <AdSenseResponsive slot={AD_SLOTS.mainBelowAttractiveness} />
      <Planner />
      <Strategies />
      <HighMomentum />
      <HotTopicList
        isMobile={isMobile}
        initialList={initialHotTopicList}
      />
      {loading && (
        <div>
          <StockListSkeleton />
          <StockListSkeleton />
        </div>
      )}

      <KbPasswordReAuthToast
        isVisible={passwordExpiredToast}
        onClose={() => setPasswordExpiredToast(false)}
        width={300}
        buttonHanlder={() => {
          setReAuthPassword(true);
          setPasswordExpiredToast(false);
        }}
      />
      <CustomToast
        isVisible={mainScreenPasswordSuccess}
        onClose={() => setMainScreenPasswordSuccess(false)}
        message={"KB증권 계좌로 인증되었어요"}
        width={270}
        duration={1500}
        successIconFill={"#34BB7A"}
      />
    </div>
  );
}

export default StockLIstIndex;
